import React from 'react';
import ReactDOM from 'react-dom/client';
// Global design tokens + primitives. (Previously nothing imported this file: the tokens only reached the page
// through an @import inside StudentSidebar.css.)
import './index.css';
import App from './App';
import { watchSystemTheme } from './utils/theme';

watchSystemTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
